import { useState } from 'react';

export function useShowModal(initialValue = false) {
  const [isModalShown, setIsModalShown] = useState(initialValue);
  const showModal = () => setIsModalShown(true);
  const hideModal = () => setIsModalShown(false);
  return { isModalShown, showModal, hideModal };
}
